import { IEntity, EntityStringId, Entity, IEntityType } from 'app/types/entity';
import vmClient from 'app/services/vmClient';
import { CopyrightLicense, CopyrightLicenseMarshaller } from 'app/constants/enums/CopyrightLicense';
import { BibliographyType, BibliographyTypeMarshaller } from 'app/constants/enums/BibliographyType';
import { LicensePartner, LicensePartnerMarshaller } from 'app/constants/enums/LicensePartner';
import { TranslationsForEntity, ALL_TRANSLATIONS } from 'app/constants/schemas/translations';

export interface IBibliography extends IEntity {
  attributes: {
    id: EntityStringId;
    type: BibliographyType;
    title: string | null;
    authors: string[] | null;
    publisher: string | null;
    url: string | null;
    copyrightLicense: CopyrightLicense;
    licensePartner: LicensePartner | null;
  };
}

export type Bibliography = Entity<IBibliography>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Bibliography: IEntityType<IBibliography> = vmClient.defineClass({
  typeName: 'Bibliography',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {
    type: {
      type: BibliographyType,
      marshaller: BibliographyTypeMarshaller,
      notNull: true,
    },
    title: 'string',
    authors: {
      type: 'string',
      collection: true,
    },
    publisher: 'string',
    url: 'string',
    copyrightLicense: {
      type: CopyrightLicense,
      marshaller: CopyrightLicenseMarshaller,
      notNull: true,
    },
    licensePartner: {
      type: LicensePartner,
      marshaller: LicensePartnerMarshaller,
    },
  },
  associations: {},
});

export const BibliographyTranslations: Partial<TranslationsForEntity<IBibliography>> = {
  id: {
    getLabel: t => t('entity-fields.Bibliography.id.label'),
  },
  type: {
    getLabel: t => t('entity-fields.Bibliography.type.label'),
  },
  title: {
    getLabel: t => t('entity-fields.Bibliography.title.label'),
  },
  authors: {
    getLabel: t => t('entity-fields.Bibliography.authors.label'),
  },
  publisher: {
    getLabel: t => t('entity-fields.Bibliography.publisher.label'),
  },
  url: {
    getLabel: t => t('entity-fields.Bibliography.url.label'),
  },
  copyrightLicense: {
    getLabel: t => t('entity-fields.Bibliography.copyrightLicense.label'),
  },
  licensePartner: {
    getLabel: t => t('entity-fields.Bibliography.licensePartner.label'),
  },
};

ALL_TRANSLATIONS.set(Bibliography, BibliographyTranslations);
